export const BASE_API_URL = process.env["REACT_APP_BASE_API_URL"] ?? "";
export const GITHUB_APP_URL = process.env["REACT_APP_GITHUB_APP_URL"] ?? "";
export const ENV = process.env["REACT_APP_ENV"] ?? "undefined";
export const MIXPANEL_TOKEN = process.env["REACT_APP_MIXPANEL_TOKEN"] ?? "";
export const MIXPANEL_ENABLED = Boolean(process.env["REACT_APP_MIXPANEL_ENABLED"]);

export const IS_EXERCISE = Boolean(process.env["REACT_APP_EXERCISE"]);
